
import React from 'react';
import moment from 'moment';
import './style.css'; // Assuming you have some CSS for styling
const ViewList = ({ items, readOnly, history }) => {
    let lastYear = 0;
    let lastMonth = 0;
    let lastDate = 0;
 
    return (
        <table style={{ width: '100%' }} >
            <tbody>
            {items.map(item => {
                let arrItems = [];
                moment(item.start).month() !== lastMonth && (arrItems.push(<tr key={item._id + 'month'}><td colSpan='2' ><div className='month'>{moment(item.start).format('MMMM')} {moment(item.start).format('YYYY')}</div></td></tr>));
                lastYear = moment(item.start).year();
                lastMonth = moment(item.start).month();

                arrItems.push(<tr key={item._id} onClick={() => {!readOnly &&       history.push('/calendar/'+item._id);}}>
                    {lastDate === moment(item.start).format("YYYY-MM-DD") ? <td style={{ verticalAlign: 'top', textAlign: 'center' }}>
                        <div className='daynumber'> </div>
                    </td> :
                        <td style={{ verticalAlign: 'top', textAlign: 'center',width:'100px' }}><div className='day'>{moment(item.start).format('dddd')}</div>
                            <div className='daynumber'> {moment(item.start).format('DD')}</div>
                        </td>
                    }

                    <td style={{ verticalAlign: 'top' }}><div className='day-item'><div className='title'>{item.title}</div> <br /> 
                    <div className='description' style={{whiteSpace:'pre-wrap'}}>{item.multiDay ? moment(item.start).format("YYYY-MM-DD")===moment(item.end).format("YYYY-MM-DD")?"t.m. " +  moment(item.end).format("HH:mm")  + " - ":"" :  moment(item.start).format("HH:mm") + " t.m. " + moment(item.end).format("HH:mm") + " - "} {item.description}</div></div></td>
                </tr>);
                lastDate = moment(item.start).format("YYYY-MM-DD");
                return arrItems;

            })}
        </tbody>
    </table>
    );
};

export default ViewList;